<template>
  <div>
    <div class="btn-group pull-right document-action">
      <template v-if="$user.isBasic()">
        <a v-if="document.publication === 'internal'" class="btn btn-sm btn-info btn-outline" :href="document.link" target="_blank">
          View document
        </a>
          <button v-else-if="$user.isSe()" class="btn btn-sm btn-info btn-outline" @click="onClick('searchDocRef', $event)" title="Subscribe to advanced Account">
            View document <i class="fa fa-lock font-bold"></i>
          </button>
        <router-link v-else :to="{name: 'DocumentReference', params: {document_id: document.documentID}}" target="_blank" class="btn btn-sm btn-sm btn-info btn-outline"> View document</router-link>
        <template v-if="document.publication !== 'internal'">
          <button class="btn btn-sm btn-info btn-outline" @click="onClick('share',$event)"> Share</button>
          <button class="btn btn-sm btn-info btn-outline" @click="onClick('cite',$event)"> Cite</button>
        </template>
        <button class="btn btn-sm btn-info" :class="(document.biblio === true) ? 'disabled' : ''"
                @click="context.addDocumentToBiblio(document)" title="Subscribe to Seeker Account">
          Save to Biblio<i class="fa fa-lock font-bold"></i>
        </button>
      </template>
      <template v-else>
        <button v-if="$auth.check('super_admin')" class="btn btn-sm btn-info btn-outline" @click="onClick('delete',$event)"> Delete</button>
        <template v-if="document.publication === 'internal' && document.link">
          <a class="btn btn-sm btn-info btn-outline" :href="document.link" target="_blank">
            View document
          </a>
        </template>
        <router-link v-else :to="{name: 'DocumentReference', params: {document_id: document.documentID}}" target="_blank" class="btn btn-sm btn-sm btn-info btn-outline"> View document</router-link>
        <template v-if="document.publication !== 'internal'">
          <button class="btn btn-sm btn-info btn-outline" @click="onClick('share',$event)"> Share</button>
          <button class="btn btn-sm btn-info btn-outline" @click="onClick('cite',$event)"> Cite</button>
        </template>

        <button class="btn btn-sm btn-info dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true"> Save to Biblio </button>
        <ul class="dropdown-menu dropdownCopyBox" aria-labelledby="dropdownCopy" style="z-index: 999999;" >
          <li style="width: 100%; padding: 5px 5px" :class="testInBoxes(generateBoxKey())? 'disabled' : ''"
              :title="testInBoxes(generateBoxKey()) ? 'Document already saved in biblio!' : 'Add document to biblio'">
            <template v-if="!testInBoxes(generateBoxKey())">
              <a style="color: 3498db"  @click="onClick('saveToBiblio',$event)"> Add to default Box : ({{$route.params.query}}) </a>
            </template>
            <template v-else>
              <a>  Add to default Box : ({{$route.params.query}})</a>
            </template>
          </li>
          <template v-if="biblioBoxes && biblioBoxes.length">
            <li role="separator" class="divider"></li>
            <div class="dropdownCopyBoxList">
              <li style="width: 100%; padding: 5px 5px" > Add to existing Box :</li>
              <li v-for="box in biblioBoxes" v-if="!testInBoxes(box.key)" :key="box.key" style="width: 100%; padding: 5px 5px"><a href="#" @click="onClick('saveTo',$event)" class="li-copyToBox text-info" :data-targetBox="box.name">{{box.name}} </a></li>
            </div>
          </template>
          <li role="separator" class="divider"></li>
          <li style="width: 100%; padding: 5px 5px" ><a href="#" @click="addKeyword" style="color:#3498db"> <i class="fa fa-plus"></i>  Add  to new box ... </a></li>
        </ul>
      </template>

    </div>
    <template v-if="showCite === true">
      <cite-modal :document="document" v-model="showCite"></cite-modal>
    </template>
    <template v-if="showShareDoc === true">
      <share-document :document="document" v-model="showShareDoc"></share-document>
    </template>
  </div>
</template>

<style scoped>
.dropdown:hover .dropdown-menu {
  display: block;
  margin-top: 0;
}

.dropdownCopyBoxList{
  max-height: 370px;
  overflow: hidden;
  overflow-y: scroll;
  padding-left: 20px;
}

.li-copyToBox {
  display: block;
  margin-left: 10px;
}

.li-copyToBox:hover {
  background-color: #f5f5f5;
}
</style>

<script>
import CiteModal from '../../components/modal/CiteModal'
import ShareDocument from '../../components/modal/ShareDocument'
import VueLadda from 'vue-ladda'
export default {
  name: 'DocumentAction',
  props: ['document', 'context', 'biblioBoxes'],
  components: {CiteModal, ShareDocument, VueLadda},
  data () {
    return {
      showCite: false,
      showShareDoc: false,
      documentInBoxes: [],
      submit: {
        loading: false,
        'dataStyle': 'zoom-in'
      },
      newKeyword: null,
      showTexteBiblio: 'default'
    }
  },
  methods: {
    onClick: function (action, event) {
      switch (action) {
        case 'delete':
          if (typeof this.document.documentID !== 'undefined') {
            this.axios.delete('document/' + this.document.documentID)
              .then((response) => {
                this.$notify({
                  type: 'success',
                  title: 'Delete document',
                  icon: 'fa trash-alt pe-7s',
                  duration: 5000,
                  content: 'Document successfully deleted',
                  placement: 'bottom-right'
                })
              }).catch((error) => {
                this.$notify({
                  type: 'danger',
                  title: 'Document cannot be deleted, it may be in a list or already deleted',
                  icon: 'fa trash-alt pe-7s',
                  duration: 5000,
                  placement: 'bottom-right'
                })
              })
          }
          break
        case 'share':
          this.showShareDoc = true
          break
        case 'cite':
          this.showCite = true
          break
        case 'searchDocRef':
          this.context.showLimitPlan('searchDocRef')
          break
        case 'saveToBiblio':
            this.context.addDocumentToBiblio(this.document)
          break
        case 'saveTo':
          if (this.$user.isBasic()) {
            this.context.showLimitPlan('advanceNews')
          } else {
            this.document.isCopyTo = true
            this.context.addDocumentToBiblio(this.document, event.target.dataset.targetbox)
          }
          break
      }
      event.stopPropagation()
      event.preventDefault()
    },
    generateBoxKey: function () {
      let query = this.$route.params.query
      return !query ? null : query.toLowerCase().replace(/(\r\n|\n|\r|\s)/gm, '').split(',').pop().replace(/[\.,'\/#!?|$%\^"&\*;:{><}=\_/`~(),]/g, '')
    },
    testInBoxes: function (key) {
      return this.documentInBoxes.find((item) => {
        if (item === key) {
          return true
        }
      })
    },
    addKeyword: function (e) {
      this.showModalAddKeyword()
      e.preventDefault()
      e.stopPropagation()
    },
    showModalAddKeyword: function () {
      if (this.$user.isBasic()) {
        this.$refs.limitPlan.show('biblio')
      } else {
        this.showTexteBiblio = 'boxWithDocument'
        $('#modalAddKeyword').modal('show')
        this.$eventHub.$emit('addKwdWithDoc', this.document)
        this.$eventHub.$emit('showTexte', this.showTexteBiblio)
      }
    }
  },
  beforeMount () {
    this.documentInBoxes = this.document.biblio ? this.document.biblio.split(';') : []
  }
}
</script>



// WEBPACK FOOTER //
// src/components/documents/DocumentAction.vue